import { useQuery } from '@apollo/client';
import { Container, Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { GET_CITIZEN_PROGRAM } from '../../../quries/citizenJoy';
import MetaSeo from '../../MetaSeo';
import CitizenMaterial from './CitizenMaterial';
import CitizenPageInfo from './CitizenPageInfo';

interface CitizenPageComponentProps {
  history: any;
  match: any;
  location: any;
  //   rowData: any;
}
function CitizenPageComponent({ match, location, history }: CitizenPageComponentProps) {
  // const metaData = {
  //   title: "노동인권문화제",
  //   description:
  //     "(사)노동인권연대가 주관하는 노동인권문화제는 2019년을 시작으로 부산시민의 노동인권과 사회연대의식 함양을 도모합니다. 이를 통해 부산이 성숙한 민주 시민사회를 선도하는 도시로 발전하도록 다양한 시민참여형 축제문화를 만들어나가고 있습니다. 노동인권문화제는 다변화 시대에 서로를 잇는 ‘연결’이라는 화두 속에 과거, 현재, 미래의 노동을 재조명하고 노동과 인권이 존중되는 지역사회 분위기 조성 및 사회 전체의 노동인권 감수성을 지속적으로 확산시키고자 합니다.",
  //   canonical: "http://laborbusan.or.kr/",
  // };

  
  const { data, loading, error } = useQuery(GET_CITIZEN_PROGRAM, {
    fetchPolicy: 'no-cache',

    variables: {
      id: match.params.citizen_joy_id,
    },
  });

  const [metaData, setMetaData] = useState({
    title: '',
    description: '',
    canonical: '',
    image: '',
  });

  const [citizenJoyProgram, setCitizenJoyProgramProgram] = useState<any>(null);
  useEffect(() => {
    if (data && data.citizenJoyProgram) {
      setCitizenJoyProgramProgram(data.citizenJoyProgram);
      setMetaData({
        title: `노동인권문화제 - ${data.citizenJoyProgram.title}`,
        description: '',
        canonical: `http://laborbusan.or.kr/citizen-joy/${match.params.citizen_joy_id}`,
        image: 'http://laborbusan.or.kr/images/main/logo1.png',
      });
    }

    return () => {
      setCitizenJoyProgramProgram(null);
    };
  }, [data]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.citizenJoyProgram) {
    console.log(error);
  }

  if (citizenJoyProgram) {
    return (
      <Container maxWidth={'xl'} disableGutters style={{}}>
        <MetaSeo data={metaData} />
        <Grid xs={12} item container justify="center" style={{}}>
          <CitizenPageInfo rowData={citizenJoyProgram} />
          <CitizenMaterial rowData={citizenJoyProgram} />
        </Grid>
      </Container>
    );
  } else {
    return <div>자료가 없습니다</div>;
  }
}
export default CitizenPageComponent;
